import { useState } from "react";
import contraindications from "../../../data/contraindications.json";

export default function Contraindications({ med }) {
    const [expanded, setExpanded] = useState(false);
    const changeView = () => setExpanded(e => !e);

    const update = (e) => {
        if (e.target.checked) {
            med.contraindications.push(e.target.name);
        } else {
            med.contraindications.splice(med.contraindications.indexOf(e.target.name), 1);
        }
    }

    return (
        <div className="contraindications">
            <div className="dropdown" onClick={changeView}>Contraindications ⮟</div>
            <div className={`checklist ${!expanded ? "hidden" : ""}`}>
                {contraindications.map((c, idx) => (
                    <div key={c} className="contraindication">
                        <label>
                            <input 
                                type="checkbox" 
                                onChange={update} 
                                data-type={"generic"}
                                data-index={idx}
                                data-key="contraindications"
                                name={c}
                                defaultChecked={med.contraindications.includes(c)}
                            />
                            {c}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    )
}